import React, { Component } from 'react';
import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';
import cjquery from 'jquery';
import language from '../../../../assets/languages/language';
import { Tooltip, Col, Row } from 'reactstrap';
import ValidateSaveReportIcon from '../../../Common/ValidateSaveReportIcon';
import { renderHTMLContent } from '../../../../common/function';
import ViewQuestion from '../../../../Components-2025/QuestionBank/ViewQuestion';
/* eslint-disable*/
class SOA_P_Beginquiz extends Component {
  constructor(props) {
    super(props);
    const initialTimerStop = JSON.parse(localStorage.getItem('timer_stop')) || false;
    this.state = {
      successAlert: false,
      token: '',
      idname: '',
      quiz_id: this.props.params.quiz_id,
      offset: this.props.params.offset ? parseInt(this.props.params.offset) : 0,
      all_question_id: '',
      question_length: '',
      timer_value: '',
      include_timer: '',
      user_time_value: '',
      first_question_id: '',
      display_question: '',
      save_text: `${language.LC().SAVE_QUESTION}`,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      timerstopbtn: initialTimerStop
        ? 'pause_btn icon-control-play'
        : 'pause_btn icon-control-pause',
      ValidToken: false,
      selectedChoice: null,
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      clicked: false,
      choice: '',
      result: '',
      text_color: 'card-header',
      records: '',
      savedQuestion: false,
      comment: 'card-block',
      flashcard: 'card-block',
      comment_data: '',
      flash_data: [],
      flash_form: 'col-md-12 display_block',
      comment_arrow: '',
      flash_card_arrow: '',
      flash_class: 'edit_right_padding',
      count: 0,
      count_end_message: '',
      timer_stop: initialTimerStop,
      timer_tag: `${language.LC().STOP}`,
      timer_display: 'card-block',
      rating: 0,
      rated: false,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      validated: false,
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class',
      comment_update_id: '',
      next_block: '',
      previ_block: '',
      already_answered_status: '',
      display_loader: 'show_block',
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().REPORT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
    };
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  tick() {
    const { count, token, idname, quiz_id } = this.state;
    if (count > 0) {
      const newCount = count - 1;
      const timerData = { token, idname, quiz_id, user_time_value: newCount };
      FD.callAPI(`${App_data.backend_api}/soa_p_quizzes/insertTimer`, timerData);
      this.setState({
        count: newCount,
        timer_display: 'card-block',
      });
    } else {
      this.setState({
        timer_display: 'card hide_block',
        count_end_message: "Time's Up",
      });
      clearInterval(this.timer);
    }
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.state.offset === 0) {
      this.setState({ previ_block: 'card hide_block' });
    }

    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState(
        {
          idname: storage_session['idname'],
          token: storage_session['token'],
        },
        () => {
          this.fetchQuizData();
          if (this.timer) {
            clearInterval(this.timer);
          }
          const initialTimerStop = JSON.parse(localStorage.getItem('timer_stop')) || false;
          this.setState({
            timer_stop: initialTimerStop,
            timerstopbtn: initialTimerStop
              ? 'pause_btn icon-control-play'
              : 'pause_btn icon-control-pause',
          });
        },
      );
    }
  }

  fetchQuizData = () => {
    const { idname, token, quiz_id, offset } = this.state;
    const requestData = { idname, token, quiz_id };
    FD.callAPI(`${App_data.backend_api}/soa_p_quizzes/getQuize`, requestData).then((resp) => {
      if (resp.success) {
        const allQuestions = JSON.parse(JSON.parse(JSON.stringify(resp.singlequiz))).all_questions;
        const questionIds = [];
        for (let i = 0; i < resp.questions_count; i++) {
          questionIds.push(allQuestions[i]);
        }
        const timerValue = Number(resp.timer_value) || 0;
        const hasUserTimeValue =
          resp.user_time_value !== undefined && resp.user_time_value !== null;
        const userTimeValue = hasUserTimeValue ? Number(resp.user_time_value) : timerValue;
        const initialTimerValue = userTimeValue > 0 ? userTimeValue : timerValue;
        const firstQuestionId = questionIds[offset];
        this.setState(
          {
            user_time_value: userTimeValue,
            count: initialTimerValue,
            count_temp: initialTimerValue,
            all_question_id: questionIds,
            question_length: questionIds.length,
            timer_value: timerValue,
            include_timer: resp.include_timer,
            first_question_id: firstQuestionId,
          },
          () => {
            if (questionIds.length - 1 === offset) {
              this.setState({ next_block: 'card hide_block' });
            }
            if (
              this.isTimerFeatureEnabled() &&
              !this.state.timer_stop &&
              !this.state.validated &&
              !this.state.selectedChoice
            ) {
              if (this.timer) clearInterval(this.timer);
              this.timer = setInterval(this.tick.bind(this), 1000);
            }
            this.fetchQuestionDetails(firstQuestionId);
          },
        );
      }
    });
  };

  fetchQuestionDetails = (questionId) => {
    const { token, idname, quiz_id, offset } = this.state;
    const requestData = { token, idname, question_id: questionId, quiz_id: quiz_id };
    FD.callAPI(`${App_data.backend_api}/soa_p_question_bank/getQuestionsbyid`, requestData).then(
      (resp) => {
        if (resp.success) {
          const questionData = resp.questionsbyid;
          this.setState({
            display_question: questionData,
            correctChoice: questionData.right_choice || '',
            display_loader: 'hide_block',
          });
          const checkData = { token, idname, quiz_id, question_id: questionId };
          FD.callAPI(`${App_data.backend_api}/soa_p_quizzes/checkAnswered`, checkData).then(
            (respInner) => {
              const questionResponse = respInner.question_recived || {};
              let selected = '';
              let showAnswer = false;
              if (questionResponse.selected_choice) {
                selected = questionResponse.selected_choice;
                showAnswer = true;
              } else if (questionResponse.id) {
                if (questionResponse.answer === 1) {
                  selected = questionData.right_choice;
                  showAnswer = true;
                } else if (!questionResponse.answer) {
                  const choices = Object.keys(questionData).filter(
                    (key) => key.startsWith('choice') && key !== questionData.right_choice,
                  );
                  selected = choices.length > 0 ? choices[0] : '';
                  showAnswer = true;
                }
              }
              this.setState({
                already_answered_status: respInner.message,
                ValidToken: true,
                selectedChoice: selected,
                clicked: showAnswer,
                validated: showAnswer,
                result_block: showAnswer ? 'card show_block' : 'card hide_block',
                text_color:
                  selected === questionData.right_choice
                    ? 'card-header text_success'
                    : 'card-header text_failure',
                result:
                  selected === questionData.right_choice
                    ? `${language.LC().CORRECT}`
                    : `${language.LC().INCORRECT}`,
                timer_stop: showAnswer || !!selected,
                timerstopbtn:
                  showAnswer || !!selected
                    ? 'pause_btn icon-control-play'
                    : 'pause_btn icon-control-pause',
              });
              if (showAnswer || !!selected) {
                if (this.timer) clearInterval(this.timer);
              } else if (this.isTimerFeatureEnabled() && !this.state.timer_stop) {
                if (this.timer) clearInterval(this.timer);
                this.timer = setInterval(this.tick.bind(this), 1000);
              }
            },
          );
          this.fetchSavedQuestionStatus(questionId);
          this.fetchFlashCards(questionId);
        }
      },
    );
  };

  fetchSavedQuestionStatus = (questionId) => {
    const { token, idname } = this.state;
    const params = { token, question_id: questionId, idname };
    FD.callAPI(`${App_data.backend_api}/soa_p_question_bank/getFavQuestions`, params).then(
      (response) => {
        if (response.success) {
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
          });
        }
      },
    );
  };

  fetchFlashCards = (questionId) => {
    const { token, idname, quiz_id, flash_class } = this.state;
    const params = { token, idname, question_id: questionId, quiz_id };
    FD.callAPI(`${App_data.backend_api}/soa_p_question_bank/getFlashCards`, params).then(
      (response) => {
        let flashCardsContent = '';
        if (response.success) {
          this.setState({ ValidToken: true });
          if (response.flash_cards.length > 0) {
            this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
            flashCardsContent = response.flash_cards.map((item) => (
              <li key={item.id}>
                <div className=''>
                  <ul className='icon_list'>
                    <li>
                      <a className='pointer_class' onClick={this._editFlash.bind(this, item)}>
                        <i className='fa fa-pencil' />
                      </a>
                    </li>
                    <li>
                      <a className='pointer_class' onClick={this._deleteFlash.bind(this, item)}>
                        <i className='fa fa-close' />
                      </a>
                    </li>
                  </ul>
                  <div className={flash_class}>
                    <h4 />
                    <p>{item.flash_card}</p>
                  </div>
                </div>
              </li>
            ));
          } else {
            this.setState({ flash_form: 'col-md-12 display_block' });
            flashCardsContent = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
          }
          this.setState({ flash_data: flashCardsContent });
        } else {
          flashCardsContent = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
          this.setState({
            ValidToken: false,
            flash_data: flashCardsContent,
            flash_form: 'col-md-12 display_block',
          });
        }
      },
    );
  };

  _navigateQuestion = (newOffset) => {
    const { token, idname, quiz_id, count, question_length, all_question_id } = this.state;
    this.setState({
      display_loader: 'show_block',
      validated: false,
      clicked: false,
      selectedChoice: null,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      save_text: `${language.LC().SAVE_QUESTION}`,
      report_block: 'card hide_block',
      timer_stop: false,
      timerstopbtn: 'pause_btn icon-control-pause',
    });
    document.getElementById('comment').value = '';
    const timerData = { token, idname, quiz_id, user_time_value: count };
    FD.callAPI(`${App_data.backend_api}/soa_p_quizzes/insertTimer`, timerData);
    this.context.router.push({
      pathname: `/soa/probability/beginquiz/${quiz_id}/${newOffset}`,
    });
    if (newOffset > 0) {
      this.setState({ previ_block: '' });
    }
    if (question_length - 1 === newOffset) {
      this.setState({ next_block: 'card hide_block' });
    } else {
      this.setState({ next_block: '' });
    }
    this.setState({ offset: newOffset });
    this.fetchQuestionDetails(all_question_id[newOffset]);
    if (this.isTimerFeatureEnabled()) {
      clearInterval(this.timer);
      if (!this.state.timer_stop) {
        this.timer = setInterval(this.tick.bind(this), 1000);
      }
    }
  };

  getNext = () => {
    this._navigateQuestion(this.state.offset + 1);
  };

  getPrevious = () => {
    this._navigateQuestion(this.state.offset - 1);
  };

  handleAnswerSelect = (choice) => {
    if (!this.state.validated) {
      this.setState({
        selectedChoice: choice[0],
        clicked: true,
        result_block: 'card hide_block',
        timer_stop: true,
        timerstopbtn: 'pause_btn icon-control-play',
      });
      if (this.timer) {
        clearInterval(this.timer);
      }
    }
  };

  getResult = (questionItem, e) => {
    const { clicked, validated, token, idname, quiz_id, all_question_id, offset, selectedChoice } =
      this.state;
    if (clicked && !validated) {
      clearInterval(this.timer);
      let isRightAnswer = 0;
      if (questionItem.right_choice === selectedChoice) {
        isRightAnswer = 1;
        this.setState({
          result: `${language.LC().CORRECT}`,
          text_color: 'card-header text_success',
          result_block: 'card show_block',
          timer_stop: true,
          timerstopbtn: 'pause_btn icon-control-play',
        });
      } else {
        isRightAnswer = 0;
        this.setState({
          text_color: 'card-header text_failure',
          result: `${language.LC().INCORRECT}`,
          result_block: 'card show_block',
          timer_stop: true,
          timerstopbtn: 'pause_btn icon-control-play',
        });
      }
      const answerData = {
        token,
        idname,
        quiz_id,
        question_id: all_question_id[offset],
        answer: isRightAnswer,
        selected_choice: selectedChoice,
      };
      FD.callAPI(`${App_data.backend_api}/soa_p_quizzes/answerQuiz`, answerData).then((resp) => {
        if (resp.success) {
          const statsData = {
            token,
            idname,
            question_id: all_question_id[offset],
            right_answer: isRightAnswer,
            time_done: 0,
          };
          FD.callAPI(`${App_data.backend_api}/soa_p_question_bank/saveStats`, statsData).then(
            (resp) => {
              if (resp.success) {
                this.setState({ ValidToken: true, validated: true });
              }
            },
          );
        } else {
          this.setState({ ValidToken: false });
        }
      });
    }
  };

  saveQuestion = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      FD.callAPI(App_data.backend_api + '/soa_p_question_bank/unsaveQuestion', data).then(
        (resp) => {
          if (resp.success) {
            this.setState({
              ValidToken: true,
              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              save_text: `${language.LC().SAVE_QUESTION}`,
              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
              bookmarkColor: '',
            });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        },
      );
    } else {
      FD.callAPI(App_data.backend_api + '/soa_p_question_bank/saveQuestion', data).then((resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            save_text: `${language.LC().Question_Saved}`,
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    }
  };

  _reportQuestion = (item, e) => {
    var comment = document.getElementById('comment').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      comment: comment,
    };
    FD.callAPI(App_data.backend_api + '/soa_p_question_bank/reportQuestion', data).then((resp) => {
      if (resp.success) {
        this.setState({ ValidToken: true, successAlert: true });
        document.getElementById('comment').value = '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  onClose = (e) => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };

  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };

  _getToggleComment = (item, e) => {
    cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };

  _getToggleFlash = (item, e) => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };

  _editFlash = (item, e) => {
    this.setState({ flash_form: 'col-sm-12 display_block' });
    document.getElementById('flash_card').value = item.flash_card;
  };

  _deleteFlash = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      flash_card: item,
    };
    FD.callAPI(App_data.backend_api + '/soa_p_question_bank/deleteFlashCard', data).then((resp) => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          flash_form: 'col-sm-12 display_block',
        });
        document.getElementById('flash_card').value = '';
        var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        this.setState({ flash_data: flash_cards });
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  timerHandler = () => {
    if (!this.isTimerFeatureEnabled()) return;
    if (this.state.validated) return;
    if (this.state.count <= 0 && !!this.state.count_end_message) return;

    const newTimerStopState = !this.state.timer_stop;
    localStorage.setItem('timer_stop', JSON.stringify(newTimerStopState));
    this.setState({
      timer_stop: newTimerStopState,
      timerstopbtn: newTimerStopState
        ? 'pause_btn icon-control-play'
        : 'pause_btn icon-control-pause',
    });

    if (newTimerStopState) {
      clearInterval(this.timer);
    } else {
      if (this.state.count > 0 && !this.state.selectedChoice) {
        clearInterval(this.timer);
        this.timer = setInterval(this.tick.bind(this), 1000);
      } else {
        this.setState({
          timer_stop: true,
          timerstopbtn: 'pause_btn icon-control-play',
        });
        localStorage.setItem('timer_stop', JSON.stringify(true));
        if (this.timer) clearInterval(this.timer);
      }
    }
  };

  isTimerFeatureEnabled = () => {
    const { include_timer, timer_value } = this.state;
    return !!include_timer || (timer_value && parseInt(timer_value, 10) > 0);
  };

  _getSummary = () => {
    this.context.router.push({
      pathname: `/soa/probability/beforeStart/${this.state.quiz_id}/${'abondon'}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: this.state.quiz_id,
        status_send: 'abondon',
      },
    });
  };

  render() {
    let questions = this.state.display_question;

    let data = '';

    let count_temp_var = this.state.count;
    let display_time = '';
    const isTimeUp = count_temp_var <= 0;

    if (typeof count_temp_var === 'number' && count_temp_var >= 0) {
      if (count_temp_var < 60) {
        display_time = `${count_temp_var} sec`;
      } else {
        const minutes = Math.floor(count_temp_var / 60);
        const seconds = count_temp_var % 60;
        display_time = `${minutes} min ${seconds} sec`;
      }
    }

    const isValidateDisabled = this.state.validated || !this.state.selectedChoice;
    const isTimerButtonDisabled =
      !this.isTimerFeatureEnabled() ||
      this.state.count <= 0 ||
      this.state.validated ||
      this.state.selectedChoice;

    return (
      <div>
        <div className='animated fadeIn'>
          <div className='row'>
            <div className='col-sm-8 margin_bottom_20'>
              <h1 className='section_head'>
                {language.LC().QUIZ_ID} : {this.state.quiz_id}
              </h1>
            </div>
            <div className='col-sm-4 margin_bottom_20 text-sm-right'>
              <button className='btn btn-primary pointer_class' onClick={this._getSummary}>
                {' '}
                {language.LC().BACK_TO_SUMMARY}{' '}
              </button>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12 col-md-12 margin_bottom_20'>
              <div className='card margin_bottom_40 font-16px'>
                <div className='card-header'>
                  <img
                    src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
                    className='margin_right_20'
                    width='30'
                    alt=''
                  />
                  {language.LC().Q} {parseInt(this.state.offset) + 1}{' '}
                  {renderHTMLContent(questions.name, 'span', '', { contentEditable: 'false' })}
                  <div className='float-right text-right'>
                    {parseInt(this.props.params.offset) === 0 ? null : (
                      <i
                        className={
                          'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block
                        }
                        onClick={this.getPrevious}
                      />
                    )}
                    <i
                      className={
                        'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block
                      }
                      onClick={this.getNext}
                    />
                  </div>
                </div>
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-9'>
                      <div className='row'>
                        <div className='col-sm-12'>
                          {renderHTMLContent(
                            questions.question,
                            'div',
                            'margin_bottom_40 view_questionhtml bg_blue',
                            { contentEditable: 'false' },
                          )}
                        </div>

                        <ViewQuestion
                          question={questions.question}
                          choice_a={questions.choice_a}
                          choice_b={questions.choice_b}
                          choice_c={questions.choice_c}
                          choice_d={questions.choice_d}
                          choice_e={questions.choice_e}
                          selectedChoice={this.state.selectedChoice}
                          onAnswerSelect={this.handleAnswerSelect}
                          isAnswered={this.state.validated}
                          correctChoice={this.state.correctChoice}
                          setAnswer={this.handleAnswerSelect}
                          showAnswer={this.state.validated}
                        />

                        <Col md={12} className='mt-2'>
                          <Row className='align-items-center'>
                            <ValidateSaveReportIcon
                              isQue={true}
                              _getResult={this.getResult}
                              clicked={isValidateDisabled}
                              _saveQuestion={this.saveQuestion}
                              _displayReportForm={this._displayReportForm}
                              all_questions={questions}
                              save_text={this.state.save_text}
                              bookmarkCSS={this.state.bookmarkCSS}
                              bookmarkColor={this.state.bookmarkColor}
                              showResult={this.state.validated || !this.state.selectedChoice}
                            />
                          </Row>
                        </Col>
                      </div>
                    </div>
                    <div className='col-sm-3'>
                      <div className='timer_outer'>
                        <i className='fa fa-clock-o' />
                        <span className='timer_box'>{display_time}</span>
                      </div>
                      <span className={'quiz_timer_btn ' + this.state.timer_display}>
                        <button
                          type='button'
                          className={this.state.timerstopbtn}
                          onClick={this.timerHandler}
                          disabled={isTimerButtonDisabled}
                        />
                      </span>
                      <p className='text-danger'>
                        {renderHTMLContent(this.state.count_end_message, 'div', '', {
                          contentEditable: 'false',
                        })}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`${this.state.result_block} font-lusitana font-16px`}>
                <div className={this.state.text_color}>{this.state.result}</div>
                <div className='card-block'>
                  {renderHTMLContent(questions.answer, 'div', '', { contentEditable: 'false' })}
                </div>
              </div>

              <div className={this.state.report_block}>
                <div className='card-header'>{language.LC().REPORT}</div>
                {!this.state.successAlert ? (
                  <div className='card-block'>
                    <div className='row'>
                      <div className='col-sm-12'>
                        <label className='form-control-label' htmlFor='textarea-input'>
                          <strong>{language.LC().COMMENT}</strong>
                        </label>
                      </div>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='comment'
                          name='comment'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                        />
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12'>
                        <button
                          type='button'
                          className='btn btn-primary active pointer_class'
                          onClick={this._reportQuestion.bind(this, questions)}
                        >
                          {language.LC().REPORT}
                        </button>
                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this._hideReportForm.bind(this, questions)}
                        >
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='card-block'>
                    <div className='row'>
                      <div className='col-sm-12 report-Success-card'>
                        <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                        <label className='form-control-label' htmlFor='textarea-input'>
                          <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                        </label>
                        <button
                          type='button'
                          className='btn btn-primary active pointer_class  min-vw-120'
                          onClick={this.onClose}
                        >
                          {' '}
                          {language.LC().CLOSE}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      </div>
    );
  }
}

class TooltipItem extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          width='18'
          alt=''
          style={{ marginLeft: '4px' }}
        />
        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}

export default SOA_P_Beginquiz;



// WEBPACK FOOTER //
// ./src/views/SOA/Probability/Beginquiz/Beginquiz.js